import React from 'react';
import TestDate from '../test-date';
import Scores from '../scores';
import ApSubjectDropdown from '../ap-subject-dropdown';

const ApForm = () => (
  <>
    <div className="portfolio-sections side-by-side">
      <ApSubjectDropdown />
      <TestDate />
    </div>
    <Scores min={1} max={5} />
  </>
);

export default ApForm;
